const Style = {

  content: 'relative max-w-screen-2xl mx-5 sm:mx-7 lg:mx-auto h-full',
  contentLeft: 'relative max-w-screen-2xl mx-1 sm:mx-1 p-1 lg:mx-1 h-full',
  left: '!ml-1',

}

export default Style;